import { Link } from 'react-router'
import { LuArrowRight, LuCheck } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { GrainOverlay } from '@/components/ui/GrainOverlay'
import { herbalWalk, courseTwo } from '@/assets/siteMedia'
import { topics, formats } from '@/data/courses'

export const CoursesContent = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader
            title="What you'll"
            accent="explore"
            description="Kandake's programmes build knowledge progressively from foundational herbal principles to advanced traditional healing systems."
            className="mb-8"
          />
          <ol className="mb-10 overflow-hidden rounded-3xl border border-base-200 bg-white">
            {topics.map((t, i) => (
              <li
                key={t}
                className="flex items-center gap-4 border-b border-base-200 px-6 py-4 last:border-b-0"
              >
                <span className="w-7 shrink-0 font-display text-sm text-gold-500">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-base text-base-700">{t}</span>
              </li>
            ))}
          </ol>
          <Reveal>
            <SitePhoto
              src={herbalWalk}
              alt="Learning about medicinal plants on a herbal walk"
              aspect="aspect-[16/9]"
            />
          </Reveal>
        </div>

        <div>
          <SectionHeader title="Learning that" accent="fits your life" className="mb-8" />
          <Reveal>
            <SitePhoto
              src={courseTwo}
              alt="A small group preparing herbal remedies together around a table"
              aspect="aspect-[16/9]"
              className="mb-6"
            />
          </Reveal>

          <div className="mb-10 space-y-4">
            {formats.map((f, index) => (
              <Reveal key={f.title} delay={index * 80}>
                <div className="flex gap-4 rounded-2xl border border-base-200 bg-white p-5 transition-colors hover:border-green-300">
                  <span
                    aria-hidden="true"
                    className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-700"
                  >
                    <LuCheck className="h-4 w-4" />
                  </span>
                  <div>
                    <h3 className="mb-1 font-display text-lg text-base-900">{f.title}</h3>
                    <p className="text-sm leading-6 text-base-600">{f.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="relative overflow-hidden rounded-3xl bg-green-950 p-7 text-base-50">
              <GrainOverlay opacity={0.03} />
              <div className="relative z-10">
                <h3 className="mb-3 font-display text-2xl text-base-50">Enrol now</h3>
                <p className="mb-6 text-base leading-7 text-base-100">
                  Current courses are listed on Eventbrite. Get in touch to enquire about upcoming
                  programmes or to arrange a bespoke session.
                </p>
                <Link
                  to={`${ROUTES.CONTACT}?service=course-workshop`}
                  className="inline-flex min-h-12 items-center justify-center gap-3 rounded-full bg-base-50 px-6 py-3 text-sm font-semibold text-green-950 transition-colors hover:bg-gold-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-4 focus-visible:ring-offset-green-950"
                >
                  Book Now
                  <LuArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
)
